/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
/* eslint-disable one-var,one-var-declaration-per-line, global-require, no-sequences, no-unused-expressions, max-len */
import React, { PropTypes } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { canUseDOM } from 'fbjs/lib/ExecutionEnvironment';
import s from './MapControl.scss';
import { connect } from 'react-redux';
import PrintModal from '../Modals/PrintModal';
// import SideDescription from '../Modals/SideDescription/SideDescription';
import { setStartPoint, setEndPoint, clearRoute, changeZoom, changeCenter } from '../../actions/routing';
import { sideDescriptionView, choseParcel, letsDrawSomeProject, chooseGrave } from '../../actions/district';
import { getPois, getHotels, getHotelsPropozycje, getPoiPropozycje, disableAdditionals, uploadParcel, fetchParcelById } from '../../actions/postGeoData';
import {
  addPoiPoint,
  addHotelPoint,
  onClickParcel,
  zoomingRectangle,
  drawBuildingGetPoint,
  drawBuildingData,
  drawBuildingParcels,
  drawBuildingPDF,
  drawBuildingValidate,
  getLimits,
} from '../../actions/mapTools';
import { setWindowViewport, setPrintViewport, changePrintToPdfStatus } from '../../actions/printSettings';
import { setSearchboxStatus } from '../../actions/style';
import { setLayersArea, setCurrentMiniMapComposition } from '../../actions/layers';
import { find } from 'lodash';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Popover from 'react-bootstrap/lib/Popover';
import ReactDOMServer from 'react-dom/server';
import hotel from './svg/Hotel.svg';
import AdresWMS from '../AdresWMS/AdresWMS';
import Lightbox from 'react-images';
import Column from './gravePopup/Column';
import Znicz from './gravePopup/Znicz';
import arrow from './svg/circle.png';
import PdfPrinter from '../PdfPrinter/PdfPrinter';

import fetch from '../../core/fetch';

const polyLineOptions = {
  position: 'bottomleft',                    // Position to show the control. Possible values are: 'topright', 'topleft', 'bottomright', 'bottomleft'
  imperial: false,                        // Show imperial or metric distances
  title: '',                              // Title for the control
  innerHtml: '&#8614;',                   // HTML to place inside the control
  classesToApply: [],                     // Classes to apply to the control
  backgroundColor: '#8f8',                // Background color for control when selected
  cursor: 'crosshair',                    // Cursor type to show when creating measurements
  clearMeasurementsOnStop: true,          // Clear all the measurements when the control is unselected
  showMeasurementsClearControl: false,    // Show a control to clear all the measurements
  clearControlTitle: 'Clear',             // Title text to show on the clear measurements control button
  clearControlInnerHtml: '&times',        // Clear control inner html
  clearControlClasses: [],                // Collection of classes to add to clear control button
  tempLine: {                             // Styling settings for the temporary dashed line
    color: '#00f',                      // Dashed line color
    weight: 2                           // Dashed line weight
  },
  line: {                                 // Styling for the solid line
    color: '#006',                      // Solid line color
    weight: 2                           // Solid line weight
  },
  startingPoint: {                        // Style settings for circle marker indicating the starting point of the polyline
    color: '#000',                      // Color of the border of the circle
    weight: 1,                          // Weight of the circle
    fillColor: '#0f0',                  // Fill color of the circle
    fillOpacity: 1,                     // Fill opacity of the circle
    radius: 3                           // Radius of the circle
  },
  lastPoint: {                            // Style settings for circle marker indicating the last point of the polyline
    color: '#000',                      // Color of the border of the circle
    weight: 1,                          // Weight of the circle
    fillColor: '#fa8d00',               // Fill color of the circle
    fillOpacity: 1,                     // Fill opacity of the circle
    radius: 3                           // Radius of the circle
  },
  endPoint: {                             // Style settings for circle marker indicating the last point of the polyline
    color: '#000',                      // Color of the border of the circle
    weight: 1,                          // Weight of the circle
    fillColor: '#f00',                  // Fill color of the circle
    fillOpacity: 1,                     // Fill opacity of the circle
    radius: 3                           // Radius of the circle
  },
};

const polyGonOptions = {
  position: 'bottomleft',                    // Position to show the control. Possible values are: 'topright', 'topleft', 'bottomright', 'bottomleft'
  imperial: false,                        // Show imperial or metric distances
  title: '',                              // Title for the control
  innerHtml: '&#8604;',                   // HTML to place inside the control
  classesToApply: [],                     // Classes to apply to the control
  backgroundColor: '#8f8',                // Background color for control when selected
  cursor: 'crosshair',                    // Cursor type to show when creating measurements
  clearMeasurementsOnStop: true,          // Clear all the measurements when the control is unselected
  showMeasurementsClearControl: false,    // Show a control to clear all the measurements
  clearControlTitle: 'Clear',             // Title text to show on the clear measurements control button
  clearControlInnerHtml: '&times',        // Clear control inner html
  clearControlClasses: [],                // Collection of classes to add to clear control button
  tempLine: {                             // Styling settings for the temporary dashed line
    color: '#00f',                      // Dashed line color
    weight: 2                           // Dashed line weight
  },
  line: {                                 // Styling for the solid line
    color: '#006',                      // Solid line color
    weight: 2                           // Solid line weight
  },
  startingPoint: {                        // Style settings for circle marker indicating the starting point of the polyline
    color: '#000',                      // Color of the border of the circle
    weight: 1,                          // Weight of the circle
    fillColor: '#0f0',                  // Fill color of the circle
    fillOpacity: 1,                     // Fill opacity of the circle
    radius: 3                           // Radius of the circle
  },
  lastPoint: {                            // Style settings for circle marker indicating the last point of the polyline
    color: '#000',                      // Color of the border of the circle
    weight: 1,                          // Weight of the circle
    fillColor: '#fa8d00',               // Fill color of the circle
    fillOpacity: 1,                     // Fill opacity of the circle
    radius: 3                           // Radius of the circle
  },
  endPoint: {                             // Style settings for circle marker indicating the last point of the polyline
    color: '#000',                      // Color of the border of the circle
    weight: 1,                          // Weight of the circle
    fillColor: '#f00',                  // Fill color of the circle
    fillOpacity: 1,                     // Fill opacity of the circle
    radius: 3                           // Radius of the circle
  },
};

const isBrowser = typeof window !== 'undefined' && window !== null;

let Map, GeometryUtil, Marker, Popup, TileLayer, L, ZoomControl, WMSTileLayer, HeatmapLayer, Rectangle, UtfGrid, GeoJSON, svgImports, ScaleControl, FeatureGroup, Polygon, Polyline, CircleMarker;

if (isBrowser) {
  Popup = require('react-leaflet/lib/Popup').default;
  Marker = require('react-leaflet/lib/Marker').default;
  Map = require('react-leaflet/lib/Map').default;
  FeatureGroup = require('react-leaflet/lib/FeatureGroup').default;
  Polygon = require('react-leaflet/lib/Polygon').default;
  Polyline = require('react-leaflet/lib/Polyline').default;
  GeometryUtil = require('leaflet-geometryutil').default;
  CircleMarker = require('react-leaflet/lib/CircleMarker').default;
  TileLayer = require('react-leaflet/lib/TileLayer').default;
  ZoomControl = require('react-leaflet/lib/ZoomControl').default;
  WMSTileLayer = require('react-leaflet/lib/WMSTileLayer').default;
  Rectangle = require('react-leaflet/lib/Rectangle').default;
  UtfGrid = require('./UtfGrid.js').default;
  GeoJSON = require('react-leaflet/lib/GeoJSON').default;
  L = require('leaflet');
  require('leaflet-draw');
  svgImports = require('./svgImports');
  require('./Leaflet.PolylineMeasure');
  require('./Leaflet.PolygonMeasure');
  require('./GetPointCoords');
  ScaleControl = require('react-leaflet/lib/ScaleControl').default;
} else {
  Map, Marker, Popup, TileLayer = ' ';
}

let skalaMapy = null;

class MapControl extends React.Component {
  constructor(props) {
    super(props);
    let onClickLayer = null;
    let onHoverLayer = null;
    this.state = {
      isMounted: false,
      viewport: canUseDOM ? { width: window.innerWidth, height: window.innerHeight } : { width: 1366, height: 768 },
      onClickLayerLimits: {},
      onHoverLayerLimits: {},
      poi: null,
      iconSize: [25, 25],
      iconAnchor: [10, 10],
      isPolygonMeasureAdded: false,
      isPolylineMeasureAdded: false,
      // popupAnchor: [-3, -76],
      shadowSize: [38, 38],
      isMeasuring: this.props.tools.isMeasuring,
      hotele: null,
      presentParcelId: -1,
      overCount: 0,
      rerender_mini: false,
      // onClickLayer,
      // onHoverLayer,
      layersIndex: this.props.layers.layersIndex,
      miniMapMouseOver: false,
      viewportMiniMap: { width: '200px', height: '200px' },
      viewMinimap: false,
      sideDescriptionModal: false,
      sideDescriptionData: null,
      isPrinting: false,
      parcelsData: {},
      chosenParcel: null,
      startPoint: null,
      endPoint: null,
      zoomToParcel: false, // Taka śmieszna zmienna żeby przybliżyć do działki
      gminaCmentarze: false,
      nazwaGminyCmentarze: false,
      selectedParcels: null,
      tablicaParceli: { features: [], type: 'FeatureCollection' },
      buildingDrawTool: this.props.buildingDrawTool,
      validatorWysokosci: true,
      showPopek: null,
      ifOferInKrosno: false,
      ifNeighborInKrosno: null,
      lightboxIsOpen: false,
      lightboxCurrentImg: 0,
      cmentarzePrzyblizene: [
        {
          gmina: "gmina_zarow",
          zoom: 18,
          center: [50.934452, 16.493225]
        },
        {
          gmina: "swiebodzice",
          zoom: 18,
          center: [50.855506, 16.322249]
        },
        {
          gmina: "gmina_siekierczyn",
          zoom: 18,
          center: [51.118520, 15.193600]
        },
        {
          gmina: "gmina_strzegom",
          zoom: 18,
          center: [50.951990, 16.350965]
        },
        {
          gmina: "gmina_swierzawa",
          zoom: 18,
          center: [51.020700, 15.889000]
        },
        {
          gmina: "jawor",
          zoom: 18,
          center: [51.060539, 16.194876]
        }
      ],
      graveyard: {
        "type": "FeatureCollection",
        "features": [],
      },
      graves: {
        "type": "FeatureCollection",
        "features": [],
      },
      wybranyGrob: null,
      oznaczenieGrobu: null,
      wybranyCmentarz: null,
      markerPos: null,
      intl: this.props.intl,
    };
    for (const i in this.props.district.layers) {
      if (this.props.district.layers[i].inFloadinWindow) this.getOnHoverLayerLimits(this.props.district.layers[i]);
      if (this.props.district.layers[i].inClickWindow) this.getOnClickLayerLimits(this.props.district.layers[i]);
    }
    // this.props.pobierzListPowiatow(this.props.district.prefix);
    this.hoverPopup = null;
    this.clickPopup = null;

    this.props.changeCenter([
      (this.props.district.bbox.miny + this.props.district.bbox.maxy) / 2,
      (this.props.district.bbox.minx + this.props.district.bbox.maxx) / 2,
    ]);
    this.prevStoreState = null;
}

  componentWillUpdate() {
    if (this.mapka) {
      let editableLayers = new L.FeatureGroup();
      this.mapka.leafletElement.addLayer(editableLayers);

      const drawPluginOptions = {
        position: 'topright',
        draw: {
          polygon: {
            allowIntersection: false, // Restricts shapes to simple polygons
            drawError: {
              color: '#e1e100', // Color the shape will turn when intersects
              message: '<strong>Oj!<strong> Nie możesz tego narysować!' // Message that will show when intersect
            },
            shapeOptions: {
              color: '#97009c',
            },
          },
          // disable toolbar item by setting it to false
          polyline: false,
          circle: false,
          rectangle: false,
          marker: false,
        },
        edit: {
          featureGroup: editableLayers, // REQUIRED!!
          remove: false,
        },
      };

      // Initialise the draw control and pass it the FeatureGroup of editable layers
      this.drawControl = new L.Control.Draw(drawPluginOptions);
      if (!this.drawControl) {
        this.mapka.leafletElement.addControl(this.drawControl);
      }
    }
  }

  setViewPort = (direction) => {
    const windowRatio = window.innerWidth / window.innerHeight;
    const A4VerticalRatio = 210 / 297;
    const A4HorizontalRatio = 297 / 210;
    const resizer = 90 / 100;
    const resizerForHorizontalHeight = 80 / 100;
    const viewport = {};
    if (direction === 'pionowo') {
      // begin building of a vertical print format with shorter dimension
      if (windowRatio > A4VerticalRatio) {
        viewport['height'] = window.innerHeight * resizer;
        viewport['width'] = window.innerHeight * A4VerticalRatio * resizer;
      } else {
        viewport['width'] = window.innerWidth * resizer;
        viewport['height'] = window.innerWidth * A4VerticalRatio * resizer;
      }
    }
    if (direction === 'poziomo') {
      if (windowRatio < A4HorizontalRatio) {
        viewport['width'] = window.innerWidth * resizer;
        viewport['height'] = window.innerWidth * A4VerticalRatio * resizerForHorizontalHeight;
      } else {
        viewport['height'] = window.innerHeight * resizerForHorizontalHeight;
        viewport['width'] = window.innerHeight * A4HorizontalRatio * resizer;
      }
    }
    return viewport;
  }

  componentDidMount() {
    this.setState({ isMounted: true });
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('orientationchange', this.handleResize);
    this.props.getPois(this.props.district.prefix);
    this.props.getHotels(this.props.district.prefix);
    this.props.getHotelsPropozycje(this.props.district.prefix);
    this.props.getPoiPropozycje(this.props.district.prefix);
    this.props.setSearchboxStatus(window.innerWidth > 767); //sets initial visibility of searchbox
    this.context.store.subscribe(this.handleChangeStore);                   //SUBSCRIBE TO STORE CHANGES

    this.props.setWindowViewport({ width: window.innerWidth, height: window.innerHeight });
    // this.props.setPrintViewport(this.setViewPort('pionowo'));
  }
  componentWillReceiveProps(newProps) {

    if (!newProps.printModalStatus && this.props.buildingDrawTool.print) {
      this.props.drawBuildingPDF(false);
    }
    if (newProps.isZoomBlocked && this.mapka) {
      this.mapka.leafletElement.scrollWheelZoom.disable();
    } else if (!newProps.isZoomBlocked && this.mapka) {
      this.mapka.leafletElement.scrollWheelZoom.enable();
    }
    if (newProps.printModalStatus !== this.props.printModalStatus || newProps.printOrientation !== this.props.printOrientation) {
      this.setState({
        viewport: newProps.printModalStatus === true ?
        this.setViewPort(newProps.printOrientation) :
          { width: window.innerWidth, height: window.innerHeight },
      }, () => {
        if (newProps.printModalStatus === true) {
          let cordsX = [];
          let cordsY = [];

          newProps.sideDescription.data && newProps.sideDescription.data.features ?
            (() => {
              newProps.sideDescription.data.features[0].geometry.coordinates[0][0].map((v, i) => {
                cordsX.push(v[0]);
                cordsY.push(v[1]);
              });
            })() : null;

          Array.prototype.max = () => {
            return Math.max.apply(null, this);
          };

          Array.prototype.min = () => {
            return Math.min.apply(null, this);
          };

          const maxX = cordsX.max();
          const maxY = cordsY.max();
          const minX = cordsX.min();
          const minY = cordsY.min();
          this.mapka.leafletElement.fitBounds([
              [maxY, maxX],
              [minY, minX],
          ]);
        }
      });
    }
    if (newProps.printOrientation !== this.props.printOrientation) {

      this.props.setWindowViewport({ width: window.innerWidth, height: window.innerHeight });
      this.props.setPrintViewport(this.setViewPort(newProps.printOrientation)); // nie wiem po co to bylo :-F
    }
    if (window.innerWidth > 767 && !this.props.searchboxStatus) {
      this.props.setSearchboxStatus(true); // sets visibility of searchbox when resizing more than 767
    }
    // newProps.finalPrintingTriggered === true ? this.setState({ viewport }) : null;}
    if ((newProps.parcel_data !== this.props.parcel_data) && newProps.parcel_data && newProps.parcel_id) {
      this.setState({ chosenParcel: null });
    }
    if ((newProps.parcelState !== this.props.parcelState) && newProps.parcelState == false) {
      this.setState({ tablicaParceli: { ...this.state.tablicaParceli, features: [] } });
    }
    if (newProps.isZooming !== this.props.isZooming) {
      if (newProps.isZooming === true) {
        this.mapka.leafletElement.dragging.disable();
      } else {
        this.mapka.leafletElement.dragging.enable();
      }
    }
    if (JSON.stringify(newProps.buildingDrawTool) !== JSON.stringify(this.state.buildingDrawTool)) {
      // if (newProps.buildingDrawTool.display && newProps.buildingDrawTool.position.length === 0) {
      if (newProps.buildingDrawTool.display !== this.state.buildingDrawTool.display) {
        this.buildingMeasuring._toggleMeasure();
      }
      this.setState({
        buildingDrawTool: newProps.buildingDrawTool,
      });
    }
    if (newProps.tools.isMeasuring !== this.state.isMeasuring) {
      this.setState({ isMeasuring: newProps.tools.isMeasuring });
    }
    if (JSON.stringify(this.props.graveyard) !== JSON.stringify(newProps.graveyard)){
      this.setState({
        graveyard: {
          ...this.state.graveyard,
          features: newProps.graveyard.features,
        },
      }, () => {
        setTimeout(() => {
          this.graveyard.leafletElement.clearLayers();
          this.graveyard.leafletElement.addData(this.state.graveyard);
        }, 250)
      });
    }
    if (JSON.stringify(this.props.graves) !== JSON.stringify(newProps.graves)){
      this.setState({
        graves: {
          ...this.state.graves,
          features: newProps.graves.features,
        },
      }, () => {
        setTimeout(() => {
          this.graves.leafletElement.clearLayers();
          this.graves.leafletElement.addData(this.state.graves);
        }, 250)
      });
    }
    if (JSON.stringify(this.state.wybranyGrob) !== JSON.stringify(newProps.wybranyGrob)){
      if(newProps.wybranyGrob !== null) {
        this.setState({
          wybranyGrob: newProps.wybranyGrob,
          oznaczenieGrobu: newProps.wybranyGrob
        }, () => {
          // Oddalamy gdy wybieramy z wyszukiwarki, po nacisnieciu mapy nie zmieniamy widoku
          if(newProps.wybranyGrob.changeZoom) {
            this.props.changeZoom(19);
            this.props.changeCenter([this.state.wybranyGrob.latlng.lat - 0.00001, this.state.wybranyGrob.latlng.lng])
          }
        });
      } else {
        this.setState({
          wybranyGrob: newProps.wybranyGrob
        });
      }

    }

    if (JSON.stringify(this.state.wybranyCmentarz) !== JSON.stringify(newProps.wybranyCmentarz)){
      this.setState({
        wybranyCmentarz: newProps.wybranyCmentarz,
      }, () => {
        newProps.wybranyCmentarz ?
          this.mapka.leafletElement.fitBounds(newProps.wybranyCmentarz)
        : null;
      });
    }

    if (JSON.stringify(newProps.intl) !== JSON.stringify(this.state.intl)) {
      this.setState({
        intl: newProps.intl,
      });
    }
  }


  handleChangeStore = () => {
    let currentValue = this.context.store.getState();
    // getPoint, measurePolyLine, measurePolygon
    if (this.prevStoreState) {
      if (currentValue.tools.currentTool) {
        if (currentValue.tools.currentTool === 'measurePolyLine' && this.prevStoreState.tools.currentTool === null) {
          this.polylineMeasureTool._toggleMeasure();
        }
        if (currentValue.tools.currentTool === 'measurePolygon' && this.prevStoreState.tools.currentTool === null) {
          this.polygonMeasureTool._toggleMeasure();
        }
        if (currentValue.tools.currentTool === 'getPoint' && this.prevStoreState.tools.currentTool === null) {
          this.getPoint._toggleMeasure();
        }
        if (currentValue.tools.currentTool === 'addPoi' && this.prevStoreState.tools.currentTool === null) {
          this.getPoint._changeMode('addPoi');
          this.getPoint._toggleMeasure();
        }
        if (currentValue.tools.currentTool === 'addHotel' && this.prevStoreState.tools.currentTool === null) {
          this.getPoint._changeMode('addHotel');
          this.getPoint._toggleMeasure();
        }
      } else {
        if (this.prevStoreState.tools.currentTool === 'measurePolyLine') {
          this.polylineMeasureTool._toggleMeasure();
        }
        if (this.prevStoreState.tools.currentTool === 'measurePolygon') {
          this.polygonMeasureTool._toggleMeasure();
        }
        if (this.prevStoreState.tools.currentTool === 'getPoint') {
          this.getPoint._toggleMeasure();
        }
        if (this.prevStoreState.tools.currentTool === 'addPoi') {
          this.getPoint._changeMode('addPoi');
          this.getPoint._toggleMeasure();
        }
        if (this.prevStoreState.tools.currentTool === 'addHotel') {
          this.getPoint._changeMode('addHotel');
          this.getPoint._toggleMeasure();
        }


        if (this.prevStoreState.postGeoData.parcel_data === null && this.props.parcel_data) {
            setTimeout(() => {
              this.foundParcel.leafletElement.clearLayers();
              this.foundParcel.leafletElement.addData(this.props.parcel_data);
              const bounds = this.foundParcel.leafletElement.getBounds()
              this.mapka.leafletElement.fitBounds(bounds);
            }, 200)
        } else if (this.props.parcel_data && this.prevStoreState.postGeoData.parcel_data){
          //if (this.props.parcel_data.coordinates[0][0][0] !== this.prevStoreState.postGeoData.parcel_data.coordinates[0][0][0]) {
          if (this.props.parcel_id !== this.prevStoreState.postGeoData.parcel_id) {
            setTimeout(() => {
              this.foundParcel.leafletElement.clearLayers();
              this.foundParcel.leafletElement.addData(this.props.parcel_data);
              const bounds = this.foundParcel.leafletElement.getBounds()
              this.mapka.leafletElement.fitBounds(bounds);
            }, 200)
          }
        }
      }
      if (this.props.printModalStatus === true && this.props.printOrientation === 'vertical' ) {
        const printMapBounds = this.printmap.leafletElement.getBounds();
        const MapBounds = this.mapka.leafletElement.getBounds();
        this.printmap.leafletElement.panInsideBounds(MapBounds);
      }

      // if new poi proposal has been added then clear layer and add new data
      //  && this.prevStoreState.tools.currentTool === 'addPoi'
      const newPorposedPoiState = this.props.pois.additionalLayers.pois_propozycje.data;
      const oldProposedPoiState = this.prevStoreState.postGeoData.additionalLayers.pois_propozycje.data;
      if (newPorposedPoiState) {
        if (oldProposedPoiState) {
          if (newPorposedPoiState.features.length !== oldProposedPoiState.features.length) {
            if (this.pois_propozycje && this.pois_propozycje.leafletElement) {
              this.pois_propozycje.leafletElement.clearLayers();
              this.pois_propozycje.leafletElement.addData(newPorposedPoiState);
            }
          }
        } else if (newPorposedPoiState.length > 0) {
          if (this.pois_propozycje && this.pois_propozycje.leafletElement) {
            this.pois_propozycje.leafletElement.clearLayers();
            this.pois_propozycje.leafletElement.addData(newPorposedPoiState);
          }

        }
        // if (this.props.pois.additionalLayers.pois_propozycje.features.length !== this.prevStoreState.postGeoData.additionalLayers.pois_propozycje.features.length) {
        //   //this.pois_propozycje.leafletElement.clearLayers();
        //   //this.pois_propozycje.leafletElement.addData(this.props.pois.additionalLayers.pois_propozycje);
        // }
      }
    }


    this.prevStoreState = currentValue;
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('orientationchange', this.handleResize);
  }

  offMoveMap = () => {
    if (this.mapka) {
      this.mapka.leafletElement.dragging.disable();
      this.mapka.leafletElement.scrollWheelZoom.disable();
    }
  }

  onMoveMap = () => {
    if (this.mapka) {
      this.mapka.leafletElement.dragging.enable();
      this.mapka.leafletElement.scrollWheelZoom.enable();
    }
  }


  onZoomEnd = (e) => {
    if (this.mapka) {
      this.props.changeZoom(e.target._zoom)
    }
  }

  onMoveEnd = () => {
    if (this.mapka) {
      const a = this.mapka.leafletElement.getCenter();
      this.props.changeCenter([a.lat, a.lng]);
    }
  }

  handleResize = () => {
    let viewport = {width: window.innerWidth, height: window.innerHeight};
    if (this.state.viewport.width !== viewport.width ||
      this.state.viewport.height !== viewport.height) {
      this.setState({ viewport });
    }
  };

  updatePosition = (markerType) => {
    if (markerType === 'start') {
      const { lat, lng } = this.markerStart.leafletElement.getLatLng();
      this.props.setStartPoint({ lat, lng });
      this.setState({ startPoint: [lat, lng] });
    } else {
      const { lat, lng } = this.markerEnd.leafletElement.getLatLng();
      this.props.setEndPoint({ lat, lng });
      this.setState({ endPoint: [lat, lng] });
    }
  }

  getLayerLimits = (layer, type) => {
    const url = `${process.env.API_URL}/layer_tile_limits`;
    const self = this;
    fetch(url + '?layerName=' + this.props.district.prefix + ':' + layer.name + '&epsg=EPSG:900913')
      .then((resp) => {
        return resp.json();
      })
      .then((resp) => {
        if (type === 'click') {
          self.setState({ onClickLayerLimits: {
            ...this.state.onClickLayerLimits,
            [layer.name]: resp.limits } });
        } else {
          self.setState({ onHoverLayerLimits: {
            ...this.state.onHoverLayerLimits,
            [layer.name]: resp.limits } });
        }
      });
  }

  getOnClickLayerLimits = (layer) => this.getLayerLimits(layer, 'click')

  getOnHoverLayerLimits = (layer) => this.getLayerLimits(layer, 'hover')


  onMouseMove = (e) => {

  }

  onClick = (e) => {

  }

  onMouseMove = (e) => {
    if (e.data) {
      if (this.hoverPopup) {
        this.hoverPopup.setLatLng(e.latlng);
      }
    } else {
      if (this.hoverPopup) {
        this.hoverPopup.closePopup();
      }
      this.hoverPopup = null;
    }
  }
//=======================================================MMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM
  createHoverPopup = (data) => {
    let tbody = '';
    return (
      <table>
        <tbody>
        {Object.keys(data).map((v, i) => {
          return (
            <tr key={i}>
              <td>{v}</td>
              <td>{data[v]}</td>
            </tr>
          )
        })}
        </tbody>
      </table>
    );
  }
  createHoverPopupS = (data) => {
    let tbody = '';
    return (
      <table>
        <tbody>
            <tr key={1}>
              <td>Typ:&nbsp;&nbsp;</td>
              <td>{data[1]}</td>
            </tr>
             <tr key={2}>
              <td>Kategoria:&nbsp;&nbsp;</td>
              <td>{data[2]}</td>
            </tr>
        </tbody>
      </table>
    );
  }
//=======================================================MMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM
  onMouseOver = (e) => {
    if (e.data) {
     let html = ReactDOMServer.renderToString(this.createHoverPopup(e.data));
      this.hoverPopup = L.popup()
        .setLatLng(e.latlng)
        .setContent(html)
        .openOn(this.mapka.leafletElement);
    } else {
      if (this.hoverPopup) {
        this.hoverPopup.closePopup();
      }
      this.hoverPopup = null;
    }
  }

  onMouseOut = (e) => {
    if (this.hoverPopup) {
      this.mapka.leafletElement.closePopup();
    }
  }

  onMouseClick = (e) => {
    if (e.data) {
     let html = ReactDOMServer.renderToString(this.createHoverPopup(e.data));
      this.clickPopup = L.popup()
        .setLatLng(e.latlng)
        .setContent(html)
        .openOn(this.mapka.leafletElement);
    } else {
      if (this.clickPopup) {
        this.clickPopup.closePopup();
      }
      this.clickPopup = null;
    }
  }

  featureClick = (e) => {
    let html = ReactDOMServer.renderToStaticMarkup(this.createHoverPopupS(e.target.feature.properties));
    this.props.sideDescriptionView(true, e.target.feature.properties);
    this.setState({
      sideDescriptionModal: true,
      sideDescriptionData: e.target.feature.properties,
    }); // switches on SideDescriptionModal
  }
  handleCloseSideDescription = () => {
    this.props.sideDescriptionView(false);
    this.setState({
      sideDescriptionModal: false,
    });
  }
  onEachFeature = (feature, layer) => {
    layer.on({
      click: this.featureClick,
    });
  }

  abc = (feature, layer) => {
    const bounds = layer.getBounds();
    return layer;
  }


  onEachFeatureParcel = (feature, layer) => {

    const parcelArrays = this.props.parcel_data.coordinates[0][0];

    const longs = parcelArrays.map((item,index) =>{
      return item[0]
    })
    const lng_min = longs.reduce((prev, curr, index, array) => {
      return prev < curr ? prev : curr
    })
    const lng_max = longs.reduce((prev, curr, index, array) => {
      return prev > curr ? prev : curr
    })
    const latts = parcelArrays.map((item,index) =>{
      return item[1]
    })
    const lat_min = latts.reduce((prev, curr, index, array) => {
      return prev < curr ? prev : curr
    })
    const lat_max = latts.reduce((prev, curr, index, array) => {
      return prev > curr ? prev : curr
    });

    const parcel_latlng = L.latLng((lat_min + lat_max) / 2, (lng_min + lng_max) / 2);
    // this.props.changeCenter(parcel_latlng);
    this.setState({ presentParcelId: this.props.parcel_id });
    if (this.mapka) {
      layer.leafletElement.clearLayers()
      layer.leafletElement.addData(feature);
      this.mapka.leafletElement.flyTo(parcel_latlng);
    }
  }

  bindPopup = (layer) => {
    return layer.feature.properties.typ;
  }

  flyToGrave = () => {
    this.mapka.leafletElement.flyTo([this.state.oznaczenieGrobu.latlng.lat, this.state.oznaczenieGrobu.latlng.lng], 22);
  }

  pointToLayer = (geoJsonPoint, latlng, layerName) => {
    const icon = L.icon({
      iconUrl: svgImports.mapowaniePoi(geoJsonPoint),
      iconSize: this.state.iconSize,
      iconAnchor: this.state.iconAnchor,
      // popupAnchor: [-3, -76],
      shadowSize: this.state.shadowSize,
      className: layerName === 'pois_propozycje' ? 'propozycje-poi-border' : '',
    });

    const marker = L.marker(latlng, { icon });
    return marker;
  }

  pointToLayerHotel = (geoJsonPoint, latlng, layerName) => {
    const icon = L.icon({
      iconUrl: hotel,
      iconSize: this.state.iconSize,
      iconAnchor: this.state.iconAnchor,
      // popupAnchor: [-3, -76],
      shadowSize: this.state.shadowSize,
      className: layerName === 'pois_propozycje' ? 'propozycje-poi-border' : '',
    });

    const marker = L.marker(latlng, { icon });
    return marker;
  }

      // isPolygonMeasureAdded: false,
      // isPolylineMeasureAdded: false,

  attachMeasurements = () => {
    if (this.mapka) {
      if (!this.polygonMeasureTool) {
        this.polygonMeasureTool = L.control.polygonMeasure(polyGonOptions);
        this.mapka.leafletElement.addControl(this.polygonMeasureTool);
      }
      if (!this.polylineMeasureTool) {
        this.polylineMeasureTool = L.control.polylineMeasure(polyLineOptions);
        this.mapka.leafletElement.addControl(this.polylineMeasureTool);
      }
      if (!this.getPoint) {
        this.getPoint = L.control.getPoint(polyLineOptions);
        this.getPoint._setCtx(this);
        this.mapka.leafletElement.addControl(this.getPoint);
      }

      if (!this.buildingMeasuring) {
        this.buildingMeasuring = L.control.polygonMeasure(polyLineOptions);
        this.mapka.leafletElement.addControl(this.buildingMeasuring);
      }
      // if (!this.state.isPolygonMeasureAdded) {
      //   this.setState({ isPolygonMeasureAdded: true }, () => {
      //     const polygonMeasureTool = L.control.polygonMeasure(polyGonOptions);
      //     this.mapka.leafletElement.addControl(polygonMeasureTool);
      //   });
      // }
      // if (!this.state.isPolylineMeasureAdded) {
      //   this.setState({ isPolylineMeasureAdded: true }, () => {
      //     const polylineMeasureTool = L.control.polylineMeasure(polyLineOptions);
      //     this.mapka.leafletElement.addControl(polylineMeasureTool);
      //   });
      // }
    }
  }

  handleCloseSD = () => {
    this.setState({ sideDescriptionModal: false });
    this.props.sideDescriptionView(false);
  }


  viewDistricktArea = (box) => {
      this.mapka.leafletElement.fitBounds(
        [[this.props.district.layers[0].boundingbox.maxy, this.props.district.layers[0].boundingbox.minx],
      [this.props.district.layers[0].boundingbox.miny, this.props.district.layers[0].boundingbox.maxx]],
      );
  };

  // powiększa minimapę
  onMouseOverMiniMap = () =>{
    this.setState({ viewportMiniMap: { width: '700px', height: '500px' }, overCount: this.state.overCount + 1 }, () => this.setState({ rerender_mini: this.state.overCount === 1 }, () => this.setState({ rerender_mini: false })));
    this.setState({ miniMapMouseOver: true });
    this.props.setCurrentMiniMapComposition;
  };

  // zmniejsza wymiary minimapy do stanu początkowego
  onMouseOutMiniMap = () =>{
    this.setState({ viewportMiniMap: {width: '200px', height: '200px'}, rerender_mini: true, overCount: 0}, () => this.setState({rerender_mini:false}));
    this.setState({ miniMapMouseOver: false });
    // this.minimap.leafletElement.fitBounds(
    //   [[this.props.district.layers[0].boundingbox.maxy, this.props.district.layers[0].boundingbox.minx],
    //   [this.props.district.layers[0].boundingbox.miny, this.props.district.layers[0].boundingbox.maxx]],
    // );
  };

  showMinimap = () =>{
    this.setState({viewMinimap: true});
  };

   hideMinimap  = () =>{
    this.setState({viewMinimap: false});
  };

  checkPointIntersection = (marker, poly) => {
    // fajna funckja która nie działa (miła sprawdzać czy punkt leży w działce)
    let polyPoints = poly.features[0].geometry.coordinates;
    let x = marker.lat, y = marker.lng;

    let inside = false;
    for (let i = 0, j = polyPoints.length - 1; i < polyPoints.length; j = i++) {
        let xi = polyPoints[i][1], yi = polyPoints[i][0];
        let xj = polyPoints[j][1], yj = polyPoints[j][0];

        let intersect = ((yi > y) != (yj > y))
            && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
        if (intersect) inside = !inside;
    }
    return inside;
  }

  onClickMapParcel = (type) => {
    const e = this.state.showPopek;
    // funkcja obslugujaca onclick na mapie

    this.props.sideDescriptionView(false, null);
    this.setState({ chosenParcel: null });


    const urlKrosno = `${process.env.API_URL}/einvest/${this.props.district.prefix}/parcel?lat=${e.latlng.lat}&lng=${e.latlng.lng}`;
    const urlInne = `${process.env.OLD_IHUB}/parcel?district=${this.props.district.prefix}&x=${e.latlng.lat}&y=${e.latlng.lng}`;
    let url;
    const isKrosnoInvest = this.props.district.prefix === 'krosno' && type == 'oferta';
    if (isKrosnoInvest) {
      url = urlKrosno;
    } else {
      url = urlInne;
    }
    this.getParcelsPolygon = (e) => {
      return fetch(url, {
        type: 'GET',
      })
      .then(resp => {
        return resp.json();
      })
      .catch(e => {
        console.info(e)
      })
    }


    this.showParcelsOnMaps = (r) => {
      // przesyla dane do minimapy w sidebarze, wlacza sidebar, ustala srodek mapy
      this.props.fetchParcelById(null, null);
      this.setState({ chosenParcel: r });
      this.props.sideDescriptionView(true, r);

      if (isKrosnoInvest){
        try {
          this.props.getLimits(this.props.district.prefix, e.latlng.lat, e.latlng.lng); // pobieramy ograniczenia na dzialce);
        }
        catch(error) {
          error => console.info(error)
        }
      } else {
        this.props.getLimits(null)
      }

      let boundingBox = null;
      let cordsX = [];
      let cordsY = [];
      r.features.map(v => {
        if ( v.geometry !== "" && v.geometry !== null ) {
          v.geometry.coordinates[0].map((v, i) => {
            cordsX.push(v[0]);
            cordsY.push(v[1]);
          });
          return;
        }
        return;
      })

      Array.prototype.max = function() {
        return Math.max.apply(null, this);
      };

      Array.prototype.min = function() {
        return Math.min.apply(null, this);
      };

      const maxX = cordsX.max();
      const maxY = cordsY.max();
      const minX = cordsX.min();
      const minY = cordsY.min();

      this.mapka.leafletElement.fitBounds([
          [maxY, maxX],
          [minY, minX]
      ]);
    }

    if (this.props.printModalStatus === false && !this.props.isMeasuring) {
      if (e.originalEvent.ctrlKey) {
        // jezeli ctrl + click na dzialki na mapie
        this.getParcelsPolygon(e).then(r => {
          let feat = r.features[0]
          this.setState({
            tablicaParceli: {
              ...this.state.tablicaParceli,
              features: [...this.state.tablicaParceli.features, feat]
            }
          }, () => this.obliczPowierzchnie());
          // tablicaParceli.features.push(feat);
          this.props.onClickParcel(true);
          this.showParcelsOnMaps(this.state.tablicaParceli);
        })
        .catch(e => {
        })
      } else {
        // jezeli click na dzialke na mapie
        this.getParcelsPolygon(e).then(r => {
          // let feat = r.features[0]
          this.setState({
            tablicaParceli: {
              ...this.state.tablicaParceli,
              features: []
            }
          }, () => this.obliczPowierzchnie());
          this.props.onClickParcel(false);
          this.showParcelsOnMaps(r);
        })
        .catch(e => {
          console.info(e)
        })
      }
    }
  }

  /**
   * Funkcja pobierajaca listę zdjęć z folderu dla danego grobu
   * @param result - wynik z fetcha pobierzGrob
   * @param lat - latlng z onClicku pobierzGrob
   * @param id_grobu - id grobu
   * @return object - imageExists - czy istnieja jakie kolwiek zdjecia, images - lista zdjec, error - tresc bledu
  */
  getImages = (result, lat, id_grobu) => {
    const url = `${process.env.API_URL}/zdjecie_grobu/${this.props.district.prefix}/${result['PK_UID']}`
    fetch(url, {
      type: 'GET',
    })
    .then(resp => {
      return resp.json();
    })
    .then(resp => {
      let arr = [];
      if(resp.imagesExists) {
        resp.images.map((v, i) => {
          arr.push({ src: `${process.env.API_URL}/zdjecie_grobu/${this.props.district.prefix}/${result['PK_UID']}/${v}` })
        })
      }
      resp.images = arr;
      this.props.chooseGrave({
        data: result,
        latlng: lat.latlng,
        images: resp,
        change: false,
        changeZoom: false
      });
    })
    .catch(e => {
      console.info(e)
    })
  }

  pobierzGrob = (e) => {
    const url = `${process.env.API_URL}/cmentarze/${this.props.district.prefix}/grob?lat=${e.latlng.lat}&lng=${e.latlng.lng}`
    fetch(url, {
      type: 'GET',
    })
    .then(resp => {
      return resp.json();
    })
    .then(resp => {
      this.getImages(resp, e, resp['id_grobu'])
    })
    .catch(e => {
      console.info(e)
    })
  }

	onClickPointOnMapka = (e) => {

    if(this.props.currentComposition && this.props.currentComposition.nazwa === "CMENTARZE") {
      return this.pobierzGrob(e)
    }

    if (this.props.printModalStatus || this.state.isMeasuring) {
      // blokuje funkcję jeżeli uruchomiony jest tryb wydruku
      return;
    }
    if (this.state.buildingDrawTool.display) {
      // gdy uruchomimy rysowanie rzutu inwestycji
      return this.getPointBuildingMeasure(e);
    }

    if (this.props.district.prefix == 'krosno') {

      const urlKrosno = `${process.env.API_URL}/einvest/${this.props.district.prefix}/parcel?lat=${e.latlng.lat}&lng=${e.latlng.lng}`;
      const urlKrosnoNeighbor =  `${process.env.API_URL}/einvest/${this.props.district.prefix}/neighbor?lat=${e.latlng.lat}&lng=${e.latlng.lng}`

      function checkIfOfert() {
        return fetch(urlKrosno, {
          type: 'GET',
        })
        .then(resp => {
          return resp.json();
        })
        .catch(e => {
          console.info(e)
        })
      }
      function checkIfNeighbor() {
        return fetch(urlKrosnoNeighbor, {
          type: 'GET',
        })
        .then(resp => {
          return resp.json();
        })
        .catch(e => {
          console.info(e)
        })
      }
      checkIfOfert().then((resp) => {
        if (resp.features[0].properties.id_oferty !== null) {
          this.setState({
            showPopek: e,
            ifOferInKrosno: true,
            ifNeighborInKrosno: null
          }, () => {
            this.onClickMapParcel('oferta');
          });
        } else {
          checkIfNeighbor().then(resp => {
            if (resp) {
              this.setState({
                showPopek: e,
                ifOferInKrosno: false,
                ifNeighborInKrosno: resp
              }), () => {
                this.onClickMapParcel('zainwestowane')
              }
            } else {
              this.props.sideDescriptionView(false, null);
              this.setState({
                showPopek: e,
                ifOferInKrosno: false,
                ifNeighborInKrosno: null
              });
            }
          })
        }
      });
    }
	}

  // ------------------------------------
  // funkcje do zaznaczania wielu działek
  // ____________________________________
  endSelection = () => {
    const d = new Date();
    const startP = this.state.startPoint;
    const endP = this.state.endPoint;
    this.setState({ startPoint: null, endPoint: null }, () => {
      const d = new Date();
      const selectTime = d.getTime() - this.state.startSelectTime;
      if (selectTime > 100) {
        fetch(`${process.env.API_URL}/eservices/${this.props.district}/parcel_in_box?latStart=${startP.lat}&lngStart=${startP.lng}&latEnd=${endP.lat}&lngEnd=${endP.lng}`,
          { method: 'GET' })
          .then(r => {
            if (r.status === 200) {
              return r.json()
            }
            throw r;
          })
          .then(response => {
            let parcels = [];
            for (let i = 0; i <= response.features.length - 1; i++) {
              const parcel = {
                value: response.features[i].properties.nr_dzialki,
                label: response.features[i].properties.nr_dzialki,
                obreb: response.features[i].properties.obreb,
              }
              parcels.push(parcel);
            }
            // this.setState({ selectedParcels: parcels, parcelFeatures: response.features }, () => this.refreshParcels());
          });
      }
    });
  }

  onMouseDownMap = (e) => {
    if(this.props.isZooming){
      const d = new Date();
      this.setState({ startPoint: e.latlng, startSelectTime: d.getTime() });
    }
  };
  onMouseMoveMap = (e) => {
    if (this.props.isZooming && this.state.startPoint) {
      this.setState({
        endPoint: e.latlng
      })
    };
  };
  onMouseUpMap  = (e) => {
    if(this.props.isZooming && this.state.startPoint){
      this.mapka.leafletElement.flyToBounds([
        this.state.startPoint,
        this.state.endPoint
      ]);
      this.setState({
        startPoint: null,
        endPoint: null
      })
    } else {
      return;
    }
  };
  // koniec funkcji do zaznacznia wielu działek
  // __________________________________________

  toggleBuildingMeasure = () => {
    this.props.toggleDrawBuilding(!this.state.buildingDrawTool.display);
  }

  getPointBuildingMeasure = (e) => {
    const latlng = [e.latlng.lat, e.latlng.lng]; // pobiera latlng z onClicka na mapie podczas rysowania
    let newlatLngTable = [...this.state.buildingDrawTool.project.position]; // pobiera latlng ze state
    newlatLngTable.push(latlng);

    const cordy = newlatLngTable.slice(0);
    let powierzchnia = Math.round(L.GeometryUtil.geodesicArea(cordy.map(x => new L.latLng(x))), 2);
    const wysokoscPoprzednia = this.state.buildingDrawTool.validation.wysokoscMax ? this.state.buildingDrawTool.validation.wysokoscMax : null;
    const validPoint = (itemy) => {
      let wrongPoints = this.state.buildingDrawTool.validation.wrongPoints ?
        [...this.state.buildingDrawTool.validation.wrongPoints] : []
      ;
      const wysokosc = () => {
        if (wysokoscPoprzednia && (Number(itemy.wysokoscMax) > Number(wysokoscPoprzednia))) {
          return wysokoscPoprzednia;
        } else {
          return itemy.wysokoscMax;
        }
      }
      if (this.state.buildingDrawTool.limits.id_oferty == itemy.id_oferty && this.state.buildingDrawTool.validation.intersect){
        this.props.drawBuildingValidate({
          ...this.state.buildingDrawTool.validation,
          intersect: true,
          wysokoscMax: wysokosc(),
          wrongPoints: [],
        })
      } else if (this.state.buildingDrawTool.limits.id_oferty != itemy.id_oferty ) {
        wrongPoints.push(e.latlng);
        this.props.drawBuildingValidate({
          ...this.state.buildingDrawTool.validation,
          intersect: false,
          wysokoscMax: wysokosc(),
          wrongPoints: wrongPoints,
        })
      } else {
        this.props.drawBuildingValidate({
          ...this.state.buildingDrawTool.validation,
          intersect: false,
          wysokoscMax: wysokosc(),
        })
      }
    }

    const url = `${process.env.API_URL}/einvest/${this.props.district.prefix}/validate?lat=${e.latlng.lat}&lng=${e.latlng.lng}`;
    fetch(
      url, {
      method: 'GET',
    }).then(
      resp => {
        return resp.json().then(value => validPoint(value))
      }
    ).catch(
      error => console.info('Błąd: ', error)
    );

    this.props.drawBuildingGetPoint(newlatLngTable);
  }

  renderPopups = () => {
    const wrongPoints = this.state.buildingDrawTool.validation.wrongPoints;
    const popups = wrongPoints.map((v,i) =>
      <Popup autoPan={false} autoclose={false} key={'wrongPoint' + i} position={v}>
        <div className="zlyPunkt-popup">
          <span className="glyphicon glyphicon-alert"></span>
          <strong>{this.state.intl.langKeys.pozaObszar}</strong>
        </div>
      </Popup>
    )
    return popups;
  }

  obliczPowierzchnie = () => {
    // oblicza powierzchnie dzialki
    let wybranaDzialka;
    if (this.state.chosenParcel && this.mapka) {
      wybranaDzialka = this.state.chosenParcel.features[0].geometry.coordinates;
      L.polygon(wybranaDzialka).addTo(this.mapka.leafletElement)

      let powierzchnia = Math.round(L.GeometryUtil.geodesicArea(wybranaDzialka[0].map(x => new L.latLng(x.reverse()))), 2);
      this.props.drawBuildingParcels({ position: wybranaDzialka, powierzchnia: powierzchnia});
    };
  }

  zaprojektuj = () => {

    this.props.sideDescriptionView(true, this.state.showPopek);
  }
  graveyardStyle = (feature, layer) => {
    return {
      color: '#c300ff',
      weight: 3,
      opacity: 0.9,
      zIndex: '1000',
    };
  };

  gravesStyle = (feature, layer) => {
    return {
      color: '#4900a3',
      weight: 3,
      opacity: 0.9,
      zIndex: '1001',
    };
  };

  centerToInvestProject = () => {
    // if (investPolygon && investPolygon.length > 2) {
    //   const getCentroid = (arr) => {
    //     return arr.reduce(function (x,y) {
    //         return [x[0] + y[0]/arr.length, x[1] + y[1]/arr.length]
    //     }, [0,0])
    //   }

    //   const centerOfThePolygon = getCentroid(investPolygon);
    //   this.props.changeCenter(centerOfThePolygon);
    // } else {
    //   this.props.changeCenter(this.props.routing.zoomLevel);
    // }
    const displayWidth = this.props.printSettings.windowViewport.width;
    if (this.props.printModalStatus) {
      return {marginLeft: `-${(displayWidth / 2)}px`};
    } else {
      return null;
    }
  }

  // render mapy
  mapRender = () => {
    let districtBounds = [
      [this.props.district.bbox.miny, this.props.district.bbox.minx],
      [this.props.district.bbox.maxy, this.props.district.bbox.maxx],
    ];

    const startIcon = L.icon({
      iconUrl: "https://cdn1.iconfinder.com/data/icons/Map-Markers-Icons-Demo-PNG/256/Map-Marker-Flag--Left-Chartreuse.png",
      iconSize: [38, 38],
      shadowSize: [38, 38],
    });
    let minimapComposition = [];
    let zoomIcon = this.mapka ? this.mapka.leafletElement.getZoom() * 3 : null;
    const arrowIcon = L.icon({
      iconUrl: arrow,
      iconSize: this.mapka ? [zoomIcon, zoomIcon] : [100, 100],
      shadowSize: this.mapka ? [zoomIcon, zoomIcon] : [96, 96],
    });

    //pętla wyciągająca warstwy przypisane do "minimapa" z propsów i dodająca je do tabeli minimapComposition
    for (let i = 0; i < this.props.district.compositions.length; i++){
      if (this.props.district.compositions[i].typ === "Minimapa"){
        for (let j = 0; j < this.props.district.compositions[i].layers.length; j++){
          minimapComposition.push(this.props.district.compositions[i].layers[j])
        }
      }
    }

    let districtBox = {
      miny: this.props.district.bbox.miny,
      minx: this.props.district.bbox.minx,
      maxy: this.props.district.bbox.maxy,
      maxx: this.props.district.bbox.maxx
    };

    let mapBox = this.mapka ? {
      miny: this.mapka.leafletElement.getBounds()._southWest.lat,
      minx: this.mapka.leafletElement.getBounds()._southWest.lng,
      maxy: this.mapka.leafletElement.getBounds()._northEast.lat,
      maxx: this.mapka.leafletElement.getBounds()._northEast.lng
    } : 0;

    let miniBox = this.minimap ? {
      miny: this.minimap.leafletElement.getBounds()._southWest.lat,
      minx: this.minimap.leafletElement.getBounds()._southWest.lng,
      maxy: this.minimap.leafletElement.getBounds()._northEast.lat,
      maxx: this.minimap.leafletElement.getBounds()._northEast.lng
    } : 0;

    let minimapBox = [];

    const DistrictsAbsoluteX = districtBox.maxx - districtBox.minx;
    let minimapAbsoluteX = miniBox.maxx - miniBox.minx;
    let CurrentViewAbsoluteX = mapBox.maxx - mapBox.minx;

    let layersBox = [];
    //instrukcja warunkowa, gdy wartość zoomLayer jest inna niz null odpala funkcję zmiany widoku
    if (this.props.layers.layersIndex != null){
      const layerName = this.props.layers.currentMapComposition.layers[this.props.layers.layersIndex].warstwa;
      const id = find(this.props.district.layers, o => o.name === layerName);
      layersBox = [[id.boundingbox.miny, id.boundingbox.minx],[id.boundingbox.maxy, id.boundingbox.maxx]];
      this.mapka.leafletElement.fitBounds(layersBox);
      this.props.setLayersArea(null);
    };

    if (CurrentViewAbsoluteX >= DistrictsAbsoluteX*1.5 && CurrentViewAbsoluteX < DistrictsAbsoluteX*9.0){
      minimapBox = [
        [mapBox.miny*0.995, mapBox.minx*0.995],
        [mapBox.maxy*1.005, mapBox.maxx*1.005]
      ]
    } else if (CurrentViewAbsoluteX > DistrictsAbsoluteX*9.0 && CurrentViewAbsoluteX < DistrictsAbsoluteX*15){
      minimapBox = [
        [mapBox.miny*0.985, mapBox.minx*0.985],
        [mapBox.maxy*1.015, mapBox.maxx*1.015]
      ]
    } else if (CurrentViewAbsoluteX > DistrictsAbsoluteX*15){
      minimapBox = [
        [46.7398, 10.8105],
        [57.2790, 28.0371]
      ]
    } else if (CurrentViewAbsoluteX < DistrictsAbsoluteX*1.5){
      minimapBox = [
        [mapBox.miny*0.999, mapBox.minx*0.999],
        [mapBox.maxy*1.001, mapBox.maxx*1.001]
      ]
    } else {
      minimapBox = districtBounds;
    }

    if (!this.state.miniMapMouseOver){};


    const endIcon = L.icon({
      iconUrl: "https://cdn1.iconfinder.com/data/icons/Map-Markers-Icons-Demo-PNG/256/Map-Marker-Flag--Right-Pink.png",
      iconSize: [38, 38],
      // iconAnchor: [22, 94],
      // popupAnchor: [-3, -76],
      shadowSize: [38, 38],
    });

    const paperFormats = {
      A4: [210, 297],
      A3: [297, 420]
    }
    let printMapWidth = this.props.printOrientation === 'pionowo' ? 210/2 : 297/2;
    let printMapHeight = this.props.printOrientation === 'pionowo' ? 297/2 : 210/2;

    const printMapStyle = {
      width: `${printMapWidth}px`,
      height: `${printMapHeight}px`,
      border: 'solid 2px black',
      zIndex: '402',
      position: 'relative',
      right: '5px',
      top: '5px',
    };

    let miniMapStyle = {
      width: this.state.viewportMiniMap.width,
      height: this.state.viewportMiniMap.height,
      border: 'solid 2px black',
      zIndex: '401',
      position: 'absolute',
      bottom: '17px',
      right: '0px',
    };

    const scaleLine = {
      imperial: false,
      position: 'bottomleft',
    }

    // //onmouse over change miniMap size
    // if (this.state.miniMapMouseOver){
    //   miniMapStyle = {
    //     width: this.state.viewportMiniMap.width,
    //     height: this.state.viewportMiniMap.height,
    //     border: 'solid 2px black',
    //     zIndex: '401',
    //     position: 'absolute',
    //     bottom: '17px',
    //     right: '0px',
    //   };
    // } else {
    //   miniMapStyle = {
    //     width: this.state.viewportMiniMap.width,
    //     height: this.state.viewportMiniMap.height,
    //     border: 'solid 2px black',
    //     zIndex: '401',
    //     position: 'absolute',
    //     bottom: '17px',
    //     right: '0px',
    //   }
    // };

    let zoomMapy  = null;
    this.mapka ? zoomMapy = this.mapka.leafletElement.getZoom() : null;

    switch (zoomMapy) {
      case 5:
        skalaMapy = "";
        break;
      case 6:
        skalaMapy = "1 : 7 000 000";
        break;
      case 7:
        skalaMapy = "1 : 3 500 000";
        break;
      case 8:
        skalaMapy = "1 : 1 800 000";
        break;
      case 9:
        skalaMapy = "1 : 850 000";
        break;
      case 10:
        skalaMapy = "1 : 420 000";
        break;
      case 11:
        skalaMapy = "1 : 200 000";
        break;
      case 12:
        skalaMapy = "1 : 100 000";
        break;
      case 13:
        skalaMapy = "1 : 50 000";
        break;
      case 14:
        skalaMapy = "1 : 25 000";
        break;
      case 15:
        skalaMapy = "1 : 15 000";
        break;
      case 16:
        skalaMapy = "1 : 7 500";
        break;
      case 17:
        skalaMapy = "1 : 5 000";
        break;
      case 18:
        skalaMapy = "1 : 3 000";
        break;

      default:
        break;
    }

    // const printerToPDF = () => (
    //   <PdfPrinter>
    //     <Map
    //       id='mapadodruku'
    //       bounds={districtBounds}
    //       ref={m => { this.printmap = m; }}
    //       style={printMapStyle}
    //       center={this.props.routing.currentCenter}
    //       zoom={this.props.routing.zoomLevel}
    //       zoomControl={false}
    //       animate
    //     >
    //       <TileLayer
    //         url='http://{s}.tile.osm.org/{z}/{x}/{y}.png'
    //       />
    //     </Map>
    //   </PdfPrinter>
    // )

    // const getComponentAsHTML = (props) => {
    //   try {
    //     return ReactDOMServer.renderToStaticMarkup(printerToPDF(props))
    //   } catch (exception) {
    //     module.reject(exception)
    //   }
    // }

    const printMap = (
      <Map
        id='mapadodruku'
        bounds={districtBounds}
        ref={m => { this.printmap = m; }}
        style={printMapStyle}
        center={this.props.routing.currentCenter}
        zoom={this.props.routing.zoomLevel}
        zoomControl={false}
        animate
      >
        <TileLayer
          url='http://{s}.tile.osm.org/{z}/{x}/{y}.png'
        />
      </Map>
    );

    { /* definicja obiektu minimapy */ }
    const miniMap = (
     this.state.viewMinimap ? <Map
        bounds={minimapBox}
        ref={m => { this.minimap = m; }}
        style={miniMapStyle}
        center={[
          (this.props.district.bbox.miny + this.props.district.bbox.maxy) / 2,
          (this.props.district.bbox.minx + this.props.district.bbox.maxx) / 2,
        ]}
        zoom={12}
        zoomControl={false}
        animate
        onMouseOver={this.onMouseOverMiniMap}
        onMouseOut={this.onMouseOutMiniMap}
        viewport={this.state.viewportMiniMap}
      >

        <TileLayer
          url='http://{s}.tile.osm.org/{z}/{x}/{y}.png'
        />

      {/*wyświetla warstwy na mini mapie*/}
        {this.props.currentComposition && minimapComposition.length > 0 ? (
            minimapComposition.sort((a, b) => parseInt(b.nr) - parseInt(a.nr)).map((v, i) => {
              const l = _.find(this.props.district.externalLayers, o => o.nazwa === v.warstwa)
              return v.isVisible ? (

                (typeof l === "undefined") ? (
                  <WMSTileLayer
                    key={i}
                    url={`${process.env.GEOSERVER}/${this.props.district.prefix}/wms?`}
                    format={'image/png'}
                    transparent
                    layers={`${this.props.district.prefix}:${v.warstwa}`}
                  />) : (
                    <WMSTileLayer
                      key={i}
                      url={l.adres}
                      format={'image/png'}
                      transparent
                      layers={l.warstwa}
                      version={l.wersja}
                      service={l.typ}
                    />
                  )
                ) : null;
            })
        ) : null}
        <Rectangle bounds={this.mapka ? this.mapka.leafletElement.getBounds() : districtBounds} />
      </Map> : null
    );

    const mapPrintingStyle = this.state.isPrinting ? "" : "";

    const parcelik = [50.244567, 23.131705];

    if(this.props.addressPolygon && this.state.zoomToParcel == false) {
      this.mapka.leafletElement.flyTo(parcelik,  18);
      this.setState({ zoomToParcel: true });
    }

    // Tutaj sprawdzamy czy ktoras gmina jest z cmentarzami
    // Jak tak to zapisujemy sobie w state nazwaGminyCmentarze
    if (this.state.gminaCmentarze == false && 
      [
        'gmina_siekierczyn',
        'gmina_strzegom',
        'gmina_swierzawa',
        'gmina_zarow',
        'jawor',
        'swiebodzice'
      ].includes(this.props.district.prefix)
    ) {
      let wyborGminy = this.state.cmentarzePrzyblizene.map(v => {
        if(v.gmina == this.props.district.prefix) {
          this.props.changeCenter(v.center);
          this.props.changeZoom(v.zoom);

          this.setState({
            gminaCmentarze: true
          })
        }
      })
    }

    this.gravePopup = (grave) => {
      return (
        <div className="gravePopup">
            {grave.data.nazwisko.map((v, i) => {
              return (
                <Column
                  name={grave.data.imie[i]}
                  s_name={grave.data.nazwisko[i]}
                  born={grave.data.data_urodzenia[i]}
                  die={grave.data.data_zgonu[i]}
                  rzad={grave.data.rzad}
                  sektor={grave.data.sektor}
                  id={grave.data.id}
                  key={v+i}
                />
              )
            })
            }
          <Znicz />
        </div>
      )
  }

    return (
      <Map
        ref={m => { this.mapka = m; }}
        onMoveEnd={() => this.onMoveEnd()}
        onZoomEnd={(e) => this.onZoomEnd(e)}
        className={mapPrintingStyle}
        style={{
          width: this.state.viewport.width,
          height: this.state.viewport.height,
          border: this.props.printModalStatus === true ? '0.3px solid black' : 'none',
        }}
        center={this.props.routing.currentCenter}
        zoom={ this.props.routing.zoomLevel }
        viewport={this.state.viewport}
        zoomControl={false}
        animate
        onMouseDown={(e) => this.onMouseDownMap(e)}
        onMouseUp={(e) => this.onMouseUpMap(e)}
        onMouseMove={(e) => this.onMouseMoveMap(e)}
        onClick={(e) => this.onClickPointOnMapka(e)}
        dragging={!this.props.isZoomBlocked}
      >

      {this.mapka && this.state.showPopek &&
      !this.state.isMeasuring &&
      !this.state.buildingDrawTool.display &&
      (this.state.buildingDrawTool.project.position.length == 0 || this.state.buildingDrawTool.project.position == null) ?
        <Popup autoPan={false} position={this.state.showPopek.latlng} onClose={ () => this.setState({showPopek: null}) }>
          <div className="popek">
            {this.state.intl.langKeys.dostepneWarstwy}
            <button key={this.state.intl.langKeys.dzialkaEwi} onClick={() => this.onClickMapParcel()}>
              {this.state.intl.langKeys.dzialkaEwi}
            </button>
            {this.state.ifOferInKrosno ?
            <button
              key={this.state.intl.langKeys.zaprojektujInwestycje}
              onClick={
                () => this.props.letsDrawSomeProject(true)
              }
            >
              {this.state.intl.langKeys.zaprojektujInwestycje}
            </button> : null }
            {this.state.ifNeighborInKrosno ?
            <button
              key={this.state.intl.langKeys.istInw}
              onClick={
                () => this.props.sideDescriptionView(true, this.state.ifNeighborInKrosno, 'zainwestowane')
              }
            >
              {this.state.intl.langKeys.istInw}
            </button> : null }
          </div>
        </Popup>
      : null }
      {
        (this.props.printModalStatus || this.props.printSettings.changePrintToPdfStatus)
        && this.state.buildingDrawTool.project.data !== null ?
        <div className="projectData-table">
          <table style={{ width: '100%' }}>
            {/* <tr>
              <td><strong>Powierzchnia inwestycji:</strong></td>
              <td>{this.state.buildingDrawTool.project.data.powierzchnia}m<sup>2</sup></td>
            </tr> */}
            {
              this.props.sideDescription.data && this.props.sideDescription.data.features[0].properties ?
              <tr>
                <td><strong>Oferta inwestycyjna:</strong></td>
                <td>{this.props.sideDescription.data.features[0].properties.nazwa}</td>
              </tr> :
              null
            }
            <tr>
              <td><strong>Wysokość inwestycji:</strong></td>
              <td>{this.state.buildingDrawTool.project.data.wysokosc}m</td>
            </tr>
            {/* <tr>
              <td><strong>Rodzaj dachu:</strong></td>
              <td>{this.state.buildingDrawTool.project.data.dach}</td>
            </tr>
            <tr>
              <td><strong>Kąt dachu:</strong></td>
              <td>{this.state.buildingDrawTool.project.data.katDachu}<sup>o</sup></td>
            </tr> */}
          </table>
        </div>
      : null }

      <ScaleControl metric position="bottomleft" imperial={false} />
      {this.props.layers.layersIndex != null ? this.viewLayersArea : null}
        <TileLayer
          attribution='&copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url='http://{s}.tile.osm.org/{z}/{x}/{y}.png'
          maxNativeZoom={19}
          maxZoom={25}
        />
        {/*Wyświetla warstwy na mapie głównej*/}
        {this.props.currentComposition ? (
            this.props.currentComposition.layers.sort((a, b) => parseInt(b.nr) - parseInt(a.nr)).map((v, i) => {
              const l = _.find(this.props.district.externalLayers, o => o.nazwa === v.warstwa);
              return v.isVisible ? (
                  typeof l === "undefined" ? (
                    <WMSTileLayer
                      url={`${process.env.GEOSERVER}/${this.props.district.prefix}/wms?`}
                      format={'image/png'}
                      transparent
                      maxZoom={30}
                      layers={`${v.warstwa}`}
                      key={`${v.nr}${v.warstwa}`}
                    />) : (
                      <WMSTileLayer
                        url={l.adres}
                        format={'image/png'}
                        transparent
                        layers={`${l.warstwa}`}
			                  maxZoom={30}
                        version={l.wersja}
                        service={l.typ}
                        key={`${v.nr}${l.warstwa}`}
                      />
                    )
                ) : null;
            })
        ) : null}

        {this.props.currentComposition ? (
            this.props.currentComposition.layers.sort((a, b) => parseInt(b.nr) - parseInt(a.nr)).map((v, i) => {
              const l = _.find(this.props.district.layers, o => o.name === v.warstwa);
              return l && v.isVisible && l.inFloadinWindow ? (
                <UtfGrid
                  key={i}
                  url={`${process.env.GEOSERVER}`}
                  format={'format=application/json;type=utfgrid'}
                  transparent
                  limits={this.state.onHoverLayerLimits[l.name]}
                  epsg="EPSG:900913"
                  callbacks={[{ event: 'mousemove', f: this.onMouseMove }, { event: 'mouseover', f: this.onMouseOver }, { event: 'mouseout', f: this.onMouseOut }]}
                  layer={`${this.props.district.prefix}:${l.name}`}
                />
                ) : null;
            })
        ) : null}

        {/* Wyświetlanie wskazanej trasy */}
        {this.props.routing.hasBothPoints ? (
          <WMSTileLayer
            url={`http://37.187.154.62:8080/geoserver/gmina_cieszanow/wms?`}
            format="image/png"
            transparent
            layers={'gmina_cieszanow:routing'}
            viewparams={encodeURI([
              'x1:' + this.props.routing.startPoint.x, 'y1:' + this.props.routing.startPoint.y,
              'x2:' + this.props.routing.endPoint.x, 'y2:' + this.props.routing.endPoint.y,
            ].join(';'))}
          />
        ) : null}

        {/*{this.state.onHoverLayerLimits && this.state.onHoverLayer ? (
          <UtfGrid
            url={`${process.env.GEOSERVER}`}
            format={'format=application/json;type=utfgrid'}
            transparent
            limits={this.state.onHoverLayerLimits}
            epsg="EPSG:900913"
            callbacks={[{ event: 'mousemove', f: this.onMouseMove }, { event: 'mouseover', f: this.onMouseOver }, { event: 'mouseout', f: this.onMouseOut }]}
            layer={`${this.props.district.prefix}:${this.state.onHoverLayer.name}`}
          />) : null
        }
        {this.state.onClickLayer && this.state.onClickLayerLimits ? (
          <UtfGrid
            url={`${process.env.GEOSERVER}`}
            format={'format=application/json;type=utfgrid'}
            transparent
            limits={this.state.onClickLayerLimits}
            epsg="EPSG:900913"
            callbacks={[{ event: 'click', f: this.onMouseClick }]}
            layer={`${this.props.district.prefix}:${this.state.onClickLayer.name}`}
          />) : null
        }*/}

        {/* Renderowanie listy poi */}
        {(this.props.pois.additionalLayers.pois.data && this.props.pois.additionalLayers.pois.isVisible && this.props.routing.zoomLevel > 13) ? (
          <GeoJSON
            ref={m => { this.pois = m; }}
            data={this.props.pois.additionalLayers.pois.data}
            style={this.stylePoi}
            pointToLayer={(geoJsonPoint, latlng) => this.pointToLayer(geoJsonPoint, latlng, 'poi')}
            bindPopup={(layer) => this.bindPopup(layer)}
            onEachFeature={(feature, layer) => this.onEachFeature(feature, layer)}
          />
        ) : null}

        {/* Renderowanie listy hoteli */}
        {(this.props.pois.additionalLayers.hotels.data  && this.props.pois.additionalLayers.hotels.isVisible && this.props.routing.zoomLevel > 13) ? (
          <GeoJSON
            ref={m => { this.hotels = m; }}
            data={this.props.pois.additionalLayers.hotels.data}
            pointToLayer={(geoJsonPoint, latlng) => this.pointToLayerHotel(geoJsonPoint, latlng, 'hotels')}
            bindPopup={(layer) => this.bindPopup(layer)}
            onEachFeature={(feature, layer) => this.onEachFeature(feature, layer)}
          />
        ) : null}

        {/* Renderowanie listy propozycji hoteli */}
        {(this.props.pois.additionalLayers.hotels_propozycje.data && this.props.pois.additionalLayers.hotels_propozycje.isVisible && this.props.routing.zoomLevel > 13) ? (
          <GeoJSON
            ref={m => { this.hotels_propozycje = m; }}
            data={this.props.pois.additionalLayers.hotels_propozycje.data}
            pointToLayer={(geoJsonPoint, latlng) => this.pointToLayerHotel(geoJsonPoint, latlng, 'hotels_propozycje')}
            bindPopup={(layer) => this.bindPopup(layer)}
            onEachFeature={(feature, layer) => this.onEachFeature(feature, layer)}
          />
        ) : null}

        {/* Renderowanie listy propozycji poi */}
        {(this.props.pois.additionalLayers.pois_propozycje.data && this.props.pois.additionalLayers.pois_propozycje.isVisible && this.props.routing.zoomLevel > 13) ? (
          <GeoJSON
            ref={m => { this.pois_propozycje = m; }}
            data={this.props.pois.additionalLayers.pois_propozycje.data}
            pointToLayer={(geoJsonPoint, latlng) => this.pointToLayer(geoJsonPoint, latlng, 'pois_propozycje')}
            bindPopup={(layer) => this.bindPopup(layer)}
            onEachFeature={(feature, layer) => this.onEachFeature(feature, layer)}
          />
        ) : null}

        {/* { Renderowanie dzialek na podstawie adresu } */}
        {(this.props.addressPolygon) ?
          (<GeoJSON
            data={this.props.addressPolygon.data}
          />) : null
        }

        {this.props.spatial.isEnabled ? (
          <WMSTileLayer
            url={`${process.env.GEOSERVER}/gmina_cieszanow/wms?`}
            format={'image/png'}
            transparent
            layers={`${this.props.district.prefix}:${this.props.spatial.layer_from}`}
            CQL_FILTER={`${this.props.spatial.queryFunction}(geom, collectGeometries(queryCollection('${this.props.district.prefix}:${this.props.spatial.layer_to}', 'geom', 'INCLUDE')));INCLUDE`}
          />
        ) : null}
        {/*<WMSTileLayer
          CQL_FILTER="INTERSECTS(geom, collectGeometries(queryCollection('gmina_cieszanow:mpzp_przeznaczenie_terenow', 'geom', 'INCLUDE')));INCLUDE"
          url={`${process.env.GEOSERVER}/gmina_cieszanow/wms?`}
          format={'image/png'}
          transparent
          layers="gmina_cieszanow:kierunki_studium"
          CQL_FILTER="INTERSECTS(geom, collectGeometries(queryCollection('gmina_cieszanow:mpzp_przeznaczenie_terenow', 'geom', 'INCLUDE')));INCLUDE"
        />*/}

        {/* renderowanie wybranej działki po wybraniu jej z listy rozwijalnej */}
        {this.props.parcel_id && this.props.sideDescription.data && this.props.sideDescription.view ? (
          <GeoJSON
            ref={abc => { this.foundParcel = abc; }}
            pointToLayer={(geoJsonPoint, latlng) => this.pointToLayer(geoJsonPoint, latlng, 'parcels')}
            data={this.props.parcel_data}
          />
        ) : null}
        {/* renderowanie wybranej działki po kliknieciu na mape */}
        {this.state.chosenParcel && (this.props.sideDescription.view || this.props.printModalStatus)? (
          <GeoJSON
            ref={abc => { this.foundParcel = abc; }}
            pointToLayer={(geoJsonPoint, latlng) => this.pointToLayer(geoJsonPoint, latlng, 'parcels')}
            data={this.state.chosenParcel}
          />
        ) : null}
        {/* <WMSTileLayer
            url={`http://37.187.154.62:8080/geoserver/swiebodzice/wms?`}
            format="image/png"
            transparent
            maxZoom={30}
            layers={'swiebodzice:cmentarze_sektory'}
          />
        <WMSTileLayer
            url={`http://37.187.154.62:8080/geoserver/swiebodzice/wms?`}
            format="image/png"
            maxZoom={30}
            transparent
            layers={'swiebodzice:cmentarze_groby'}
          /> */}
        {/*selection rectangle*/}
        {(this.state.startPoint && this.state.endPoint && this.props.isZooming) ? (
          <Rectangle
            bounds={[[this.state.startPoint.lat, this.state.startPoint.lng], [this.state.endPoint.lat, this.state.endPoint.lng]]}
          />
        ) : null }

        {/*this.props.parcel_id && this.state.parcelsData.latlng ?
          <Popup keepInView={true} position={this.state.parcelsData.latlng}>
            <span>A pretty CSS3 popup.<br/>Easily customizable.</span>
          </Popup>
        : null*/}


        {/* Markery do wyświetlania początku i końca szukanej trasy */}
        {this.props.routing.hasBothPoints ? (
          <Marker
            position={[this.props.routing.startPoint.y, this.props.routing.startPoint.x]}
            name="startPoint"
            draggable
            icon={startIcon}
            onDragend={() => this.updatePosition('start')}
            ref={(marker) => { this.markerStart = marker; }}
          >
            <Popup>
              <span>Start trasy.</span>
            </Popup>
          </Marker>
        ) : null}
        {this.props.routing.hasBothPoints ? (
          <Marker
            position={[this.props.routing.endPoint.y, this.props.routing.endPoint.x]}
            name="endPoint"
            draggable
            icon={endIcon}
            onDragend={() => this.updatePosition('end')}
            ref={(marker) => { this.markerEnd = marker; }}
          >
            <Popup>
              <span>Koniec trasy.</span>
            </Popup>
          </Marker>
        ) : null}


        {/* {this.state.graveyard ? (
            <GeoJSON
              ref={abc => { this.graveyard = abc; }}
              style={this.graveyardStyle()}
              data={this.state.graveyard}
            />
          )
          : null
        } */}
        {/* {this.state.graves ? (
            <GeoJSON
              ref={abc => { this.graves = abc; }}
              style={this.gravesStyle()}
              data={this.state.graves}
            />
          )
          : null
        } */}

        {this.state.oznaczenieGrobu ?
          <Marker
          position={[this.state.oznaczenieGrobu.latlng.lat, this.state.oznaczenieGrobu.latlng.lng]}
          name="arrow"
          icon={arrowIcon}
        /> : null}

        {this.state.wybranyGrob ?
          <Popup autoPan={false} position={this.state.wybranyGrob.latlng} onClose={ () => this.props.chooseGrave(null) }>
            <div>
              {this.state.wybranyGrob.data.imie != "NN"
              && this.state.wybranyGrob.data.imie != null
              && this.state.wybranyGrob.data.imie != ''
              ? this.state.wybranyGrob.data.imie.map((v, i) => {
                return <div style={{ fontSize: '18px' }}>
                  <b><span className={{ fontSize: '22px' }}>{v}</span> {this.state.wybranyGrob.data.nazwisko[i]}</b><br />
                  Data urodzenia: {this.state.wybranyGrob.data.data_urodz == null ? this.state.wybranyGrob.data.data_urodzenia[i] : this.state.wybranyGrob.data.data_urodz[i]}<br />
                  {/* &#10014; - krzyżyk */}
                  Data zgonu: {this.state.wybranyGrob.data.data_zgonu[i]}<br />
                  {this.state.wybranyGrob.data.wiek != null ? <div>{v.slice(-1) == "a" && v != 'Kuba' ? 'Żyła lat:' : 'Żył lat:'} {typeof(this.state.wybranyGrob.data.wiek) == "string" ? this.state.wybranyGrob.data.wiek : this.state.wybranyGrob.data.wiek[i]}<br /></div> : null}
                  {this.state.wybranyGrob.data.nr_ewid_sektor != null ? <div>Sektor: {this.state.wybranyGrob.data.nr_ewid_sektor}<br /></div> : null}
                  {this.state.wybranyGrob.data.nr_ewid_rzad != null ? <div>Rząd: {this.state.wybranyGrob.data.nr_ewid_rzad}<br /></div> : null}
                  {this.state.wybranyGrob.data.nr_ewid_grob != null ? <div>Numer grobu: {this.state.wybranyGrob.data.nr_ewid_grob}</div> : null}<br />
                </div>
              })
              : <div style={{ fontSize: '18px' }}>Brak danych o&nbsp;zmarłych<br />
                  {this.state.wybranyGrob.data.nr_ewid_sektor != null ? <div>Sektor: {this.state.wybranyGrob.data.nr_ewid_sektor}<br /></div> : null}
                  {this.state.wybranyGrob.data.nr_ewid_rzad != null ? <div>Rząd: {this.state.wybranyGrob.data.nr_ewid_rzad}<br /></div> : null}
                  {this.state.wybranyGrob.data.nr_ewid_grob != null ? <div>Numer grobu: {this.state.wybranyGrob.data.nr_ewid_grob}</div> : null}<br />
                </div>
              }
              {this.state.wybranyGrob.images.imagesExists ?
              <div>
                {this.state.wybranyGrob.images.thumb
                ? <div className="graveThumb"
                    onClick={() => this.setState({ lightboxIsOpen: true })}
                    style={{backgroundImage: `url('data:image/jpeg;base64,${this.state.wybranyGrob.images.thumb}')`}}
                    title="Aby obejrzeć zdjęcia grobu, kliknij.">
                  </div>
                : <button className="btn btn-block perfectCenter marginesy cmentarze-background"
                      onClick={() => this.setState({ lightboxIsOpen: true })}
                      title="Aby obejrzeć zdjęcia grobu, kliknij.">
                    <span key={this.state.intl.langKeys.images}
                      style={{ height: '100%', marginRight: '10px' }}>Zdjęcia</span>
                    <span className="fa fa-file-image-o fa-2x" aria-hidden="true" />
                  </button>
                }
                <Lightbox
                currentImage={this.state.lightboxCurrentImg}
                images={this.state.wybranyGrob.images.images}
                isOpen={this.state.lightboxIsOpen}
                onClose={() => this.setState({ lightboxIsOpen: false, lightboxCurrentImg: 0 })}
                onClickNext={() => this.setState({ lightboxCurrentImg: this.state.lightboxCurrentImg + 1 })}
                onClickPrev={() => this.setState({ lightboxCurrentImg: this.state.lightboxCurrentImg - 1 })}
              />
            </div> : null}
            <hr/>
            <div className="text-center">
                <a
                  href={`https://maps.google.com/maps?saddr=Current+Location&daddr=${this.state.oznaczenieGrobu.latlng.lat},${this.state.oznaczenieGrobu.latlng.lng}`}
                  target="_blank"
                  className="btn btn-default btn-block">
                  <span className="glyphicon glyphicon-road">&nbsp;</span>
                  <span>Wyznacz trasę</span>
                </a>
            </div>
            </div>
          </Popup>
        : null }

        {/* Marker wyświetlający środek mapy - to tak aby widzieć środek */}
        {/*<Marker position={this.props.routing.currentCenter}>
          <Popup>
            <span>A pretty CSS3 popup. <br /> Easily customizable.</span>
          </Popup>
        </Marker>*/}
        <ReactCSSTransitionGroup
          transitionName="moveFromLeft"
          transitionEnterTimeout={0}
          transitionLeaveTimeout={0}
        >

        {/* renderowanie narysowanego budynku za pomoca narzedzia draw building tool */}
        { this.mapka && this.state.buildingDrawTool.project.position ?
        <FeatureGroup color={this.state.buildingDrawTool.validation.intersect ? 'green' : 'red'}>
          <Polygon positions={this.state.buildingDrawTool.project.position}/>
        </FeatureGroup>
        : null }

        {this.mapka && !this.state.buildingDrawTool.validation.intersect ?
          this.renderPopups() : null
        }

          {/* {this.props.sideDescription.view ? <SideDescription closeSideDescription={this.handleCloseSideDescription} /> : null} */}
        </ReactCSSTransitionGroup>
        <ZoomControl position="bottomleft" />
        {/*{miniMap}*/}
        {miniMap ? this.state.rerender_mini ? null : miniMap : null}
        {/*this.props.printModalStatus === true ? null : <div>{miniMap}</ div>*/}
        {this.props.printModalStatus === true ?
          <PrintModal DBTool={this.props.buildingDrawTool}
            offMove={() => this.offMoveMap()}
            onMove={() => this.onMoveMap()}>
            {printMap}
          </PrintModal>
          : null}
        {this.attachMeasurements()}
      </Map>
    );
  }

  render() {
    return (
      <div>
      {/* let drawControl = new L.Control.Draw(drawPluginOptions);
      this.mapka.leafletElement.addControl(drawControl); */}
      {this.props.district.prefix === "gmina_cieszanow" ?
        <div id="adreswms">

          <AdresWMS
            district={this.props.district}
            mapka={this.mapka}
          />
        </div>
        : null}
        <div className="map-scale">{skalaMapy}</div>
        {this.state.oznaczenieGrobu ?
          <button onClick={this.flyToGrave} className="maxymalize-graveyard-button"><span className="glyphicon glyphicon-zoom-in" style={{ fontSize: '26px' }}></span><br />Przybliż do <br/>grobu</button>
        : null}
        {this.state.viewMinimap && !this.state.miniMapMouseOver ?
          <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={<Popover id="popover-trigger-hover" >Ukryj minimapę</Popover>}>
            <button onClick={this.hideMinimap}className="minimalize-button"><span className="glyphicon glyphicon-chevron-down"></span></button>
          </OverlayTrigger>
        : null}
        {!this.state.viewMinimap ?
          <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={<Popover id="popover-trigger-hover" >Pokaż minimapę</Popover>}>
            <button onClick={this.showMinimap} className="maxymalize-button"><span className="glyphicon glyphicon-chevron-up"></span></button>
          </OverlayTrigger>
        : null}
        <div>
        {this.state.isMounted ?
          <PdfPrinter
            printSettings={this.props.printSettings}
            changePrintToPdfStatus={this.props.changePrintToPdfStatus}
            setPrintStatus={this.props.setPrintStatus}
            onMove={this.onMoveMap}
          >
            {this.mapRender()}
          </PdfPrinter>
          : null}
        </div>
      </div>
    );
  }
}

MapControl.propTypes = {
  setSearchboxStatus: PropTypes.func,
  searchboxStatus: PropTypes.bool,
  setWindowViewport: PropTypes.func,
  setPrintViewport: PropTypes.func,
};

MapControl.contextTypes = {
  store: React.PropTypes.object,
};

const mapState = (state) => ({
  intl: state.intl,
  layers: state.layers,
  district: state.district.district,
  currentComposition: state.layers.currentMapComposition,
  routing: state.routing,
  pois: state.postGeoData,
  tools: state.tools,
  spatial: state.tools.spatial_analysis,
  parcel_id: state.postGeoData.parcel_id,
  parcel_data: state.postGeoData.parcel_data,
  printModalStatus: state.printSettings.printModalStatus,
  printOrientation: state.printSettings.printOrientation,
  printSettings: state.printSettings,
  finalPrintingTriggered: state.printSettings.finalPrintingTriggered,
  searchboxStatus: state.style.searchboxStatus,
  sideDescription: state.district.sideDescription,
  chosenParcel: state.district.chosenParcel,
  isMeasuring: state.tools.isMeasuring,
  addressPolygon: state.district.addressPolygon,
  parcelState: state.tools.parcelState,
  isZooming: state.tools.isZooming,
  buildingDrawTool: state.tools.buildingDrawTool,
  isZoomBlocked: state.tools.isZoomBlocked,
  graveyard: state.district.graveyard,
  graves: state.district.graves,
  sectors: state.district.sectors,
  wybranyGrob: state.district.chosenGrave,
  wybranyCmentarz: state.district.chosenGraveyard
});

let mapDispatch = {
  setStartPoint,
  setEndPoint,
  clearRoute,
  changeZoom,
  changeCenter,
  // Poprawa błędów cmentarzy
  getPois,
  getHotels,
  getHotelsPropozycje,
  getPoiPropozycje,
  addPoiPoint,
  addHotelPoint,
  disableAdditionals,
  setWindowViewport,
  setPrintViewport,
  setSearchboxStatus,
  setLayersArea,
  setCurrentMiniMapComposition,
  sideDescriptionView,
  choseParcel,
  uploadParcel,
  fetchParcelById,
  onClickParcel,
  zoomingRectangle,
  drawBuildingGetPoint,
  drawBuildingData,
  drawBuildingParcels,
  drawBuildingPDF,
  getLimits,
  drawBuildingValidate,
  letsDrawSomeProject,
  chooseGrave,
  changePrintToPdfStatus,
};

export default withStyles(s)(connect(mapState, mapDispatch)(MapControl));



// WEBPACK FOOTER //
// src/components/MapControl/MapControl.js